export const COMBO_LOCALE = {
    placeholder: 'è¯·éæ©',
    emptyMsg: 'ææ æ°æ®'
};
